<template>
  <div class="farmDetailApp" :style="'height:'+curHeight+'px;background:url('+bg+') no-repeat;background-size:100% 100% !important;'" v-loading.fullscreen.lock="fullscreenLoading" element-loading-text="数据加载中" element-loading-background="rgba(0, 0, 0, 0)" element-loading-spinner="el-icon-loading"  @scroll=handleScroll>
    <swiper :options="swiperOption">
      <swiper-slide class="swiper-slide" v-for="(item,i) in farm.img">
        <a><img :src="baseUrl+item"></a>
      </swiper-slide>
    </swiper>

    <div class="title">
      <h2>{{farm.title}}</h2>
      <p>
        <span :style="farm.status == 0 ? 'color:#FE8A17' : ''">{{farm.status == 0 ? '未租' : '已租'}}</span>
        <font>{{farm.address}}</font>
      </p>
      <p class="last" v-if="farm.timer == null">有效期：{{startTime}}~{{endTime}}</p>
      <p class="last" v-if="farm.timer != null">有效期：{{farm.timer.paytime}}~{{farm.timer.lentime}}</p>
    </div>
    <div v-if="farm.status == 1" style="height:15px"></div>
    <ul class="cate" v-if="farm.status == 0">
      <li :class="curt == i ? 'curt' : ''" v-for="(vo,i) in farm.cate" @click="choose(vo.title,vo.rate,i,vo.id)">
        <h2>{{vo.title == 1 ? '一个季度卡' : vo.title == 2 ? '半年卡' : '一年年卡'}}</h2>
        <div class="price">
          <i><b>¥</b> {{vo.rate.split(".")[0]}}.<b>{{vo.rate.split(".")[1]}}</b></i>
          <span>{{vo.price}}</span>
        </div>
        <div class="area">{{parseInt(vo.area)}}m²</div>
      </li>
    </ul>

    <div class="tab" :style="scrollTag == true ? 'position:fixed;top:0;width:100%;left:0;z-index:999;background:#fff' : ''">
      <h2 @click="toggle(1)" :class="active == 1 ? 'curt' : ''">详情</h2>
      <h2 @click="toggle(2)" :class="active == 2 ? 'curt' : ''">种植计划</h2>
      <h2 @click="toggle(3)" :class="active == 3 ? 'curt' : ''">评价</h2>
      <h2 @click="toggle(4)" :class="active == 4 ? 'curt' : ''">日志</h2>
    </div>

    <div class="content">
      <div class="desc" v-html="farm.content" v-if="active == 1">
      </div>

      <div class="plan" v-if="active == 2">
        <el-steps direction="vertical">
          <el-step v-for="(item,i) in farm.plan" :title="item.title+' - '+item.starttime" :description="item.title"></el-step>
        </el-steps>
      </div>

      <div class="comment" v-if="active == 3">
        <input type="text" placeholder="说点什么吧" readonly="readonly" @click="toPush(farm.id,'comment')" />
        <dl>
          <dd v-for="(item,i) in setcomment" @click="toPush(item.id,'reply')">
            <img class="avatar" :src="item.avatar">
            <div class="plnr">
              <h2>
                <span>{{item.reply_id == 0 ? item.username : item.username + ' 回复了 ' + item.reply_user}}</span>
                <font>{{item.createtime}}</font>
              </h2>
              <p>{{item.content}}</p>
            </div>
          </dd>
        </dl>

      </div>

      <div v-if="active == 4" class="log">
        <input type="text" placeholder="赶快上传您的日志吧" readonly="readonly"  @click="gos12(farm.id)" />
        <div class="logBook">
          <div class="log-list" v-for="(item,i) in setlog">
            <div class="img" :style="'background:url('+baseUrl+item.img+') no-repeat;background-size: 100% 100%'"></div>
            <h2>{{item.title}}</h2>
            <p>{{item.createtime}}</p>
          </div>
          
        </div>
      </div>

      <div style="height:65px"></div>
    </div>
    <div class="footers">
      <span>{{farm.status == 0 ? '订购菜园' : '该菜园已被订购，欢迎您的光临！'}}</span>
      <a v-if="farm.status == 0" @click="payment">立即购买</a>
      <div class="price" v-if="farm.status == 0">
        <i><b>¥</b> {{rate.split(".")[0]}}.<b>{{rate.split(".")[1]}}</b></i>
      </div>
    </div>
  </div>
</template>

<script>
  import { swiper, swiperSlide } from 'vue-awesome-swiper'
  export default {
    data() {
      return {
        swiperOption: {
          autoplay : {
            disableOnInteraction: false, //用户操作后是否禁止自动循环
            delay: 1000 //自自动循环时间
          }, //可选选项，自动滑动
          initialSlide: 0,
          speed: 1000, //切换速度，即slider自动滑动开始到结束的时间（单位ms）
          loop:false, //循环切换
          grabCursor: true, //设置为true时，鼠标覆盖Swiper时指针会变成手掌形状，拖动时指针会变成抓手形状
          autoHeight: true,   //自动高度。设置为true时，wrapper和container会随着当前slide的高度而发生变化。   
          scrollbar: '.swiper-scrollbar',
          mousewheelControl: true, //设置为true时，能使用鼠标滚轮控制slide滑动
          observeParents: true, //当改变swiper的样式（例如隐藏/显示）或者修改swiper的子元素时，自动初始化swiper
       
          pagination: {
            el: '.swiper-pagination',
            clickable :true, //点击分页器的指示点分页器会控制Swiper切换
          },     
        },

        userData:[],
        scrollTag:false,
        curHeight:0,
        fullscreenLoading: false,
        baseUrl:'',
        active:1,
        bg:require('../../assets/images/farm.png'),
        farm:[],
        rate:0,
        endTime:'',
        startTime:'',
        curt:0,
        setlog:[],
        setcomment:[],
        cate_id:''
      };
    },
    created(){
      this.userData = localStorage.getItem('user') == null ? [] : JSON.parse(localStorage.getItem('user'));
      window.addEventListener('scroll', () => {
        let scrollTop = document.documentElement.scrollTop || document.body.scrollTop || document.querySelector('.farmDetailApp').scrollTop;
        console.log(scrollTop)
        if (scrollTop > 635) {
          this.scrollTag = true
        } else {
          this.scrollTag = false
        }
      }, true);
    },
    beforeMount() {
      this.baseUrl = this.$host;
      document.addEventListener('WeixinJSBridgeReady', function onBridgeReady() {
        WeixinJSBridge.call('hideOptionMenu');
      });
    },
    mounted() {
      this.beforeMount();
      this.getFarm();
    },

    methods: {
      beforeMount:function(){
        var h = document.documentElement.clientHeight || document.body.clientHeight;
        this.curHeight =h; //减去页面上固定高度height
      },
      toPush:function(index,url){
        this.$router.push({
          path:url,
          query:{
            id:index
          }
        })
      },

      gos12:function(id){
        window.location.href="http://user.4008005216.com/main/log?id="+id
      },
      addMonth:function(num) {
        var date = new Date();
        var dt = new Date(date.getFullYear(), date.getMonth()+1, date.getDate());
        dt.setMonth(dt.getMonth() + num);
        var y = dt.getFullYear();
        var m = dt.getMonth();
        var d = dt.getDate();
        //坑爹啊，月份是从0开始啊！！！！
        if (m == 0) { m = 12; y = y - 1; }
        if (m < 10) m = '0' + m;
        if (d < 10) d = '0' + d;
        this.endTime = y + '-' + m + '-' + d;
        this.startTime = date.getFullYear() + '-' + (date.getMonth()+1) + '-' + date.getDate();
      },
      choose:function(s,rate,i,cate_id){
        this.curt = i
        this.rate = rate;
        this.cate_id = cate_id;
        var si = s == 1 ? 3 : s == 2 ? 6 : 12;
        this.addMonth(si);
      },

      getFarm:function(){
        var that = this; 
        that.fullscreenLoading = true;
        var id = this.$route.query.id;
        this.axios({
          method:'post',
          url:that.$host+'home/farm/detail',
          params:{
            id:id
          }
        }).then(function(response){
          var res = response.data.data;
          that.farm = res;
          that.rate = res.cate[0].rate;
          that.title = res.cate[0].title;
          that.cate_id = res.cate[0].id;
          var si = res.cate[0].title == 1 ? 3 : res.cate[0].title == 2 ? 6 : 12;
          that.addMonth(si);
          that.fullscreenLoading = false
        }).catch(err=>{
          console.log('请求失败:'+err);
          that.fullscreenLoading = false
        });
      },

      getLog:function(){
        var that = this; 
        that.fullscreenLoading = true;
        var id = this.$route.query.id;
        this.axios({
          method:'post',
          url:that.$host+'home/farm/log',
          params:{
            id:id
          }
        }).then(function(response){
          var res = response.data.data;
          that.setlog = res;
          that.fullscreenLoading = false
        }).catch(err=>{
          console.log('请求失败:'+err);
          that.fullscreenLoading = false
        });
      },

      getComment:function(){
        var that = this; 
        that.fullscreenLoading = true;
        var id = this.$route.query.id;
        this.axios({
          method:'post',
          url:that.$host+'home/farm/comment',
          params:{
            id:id
          }
        }).then(function(response){
          var res = response.data.data;
          that.setcomment = res;
          that.fullscreenLoading = false
        }).catch(err=>{
          console.log('请求失败:'+err);
          that.fullscreenLoading = false
        });
      },

      payment:function(){
        var that = this;
        var id = this.$route.query.id;

        that.axios({
          method:'post',
          url:that.$host+'home/farm/weixinPay',
          params:{
            farm_id:id,
            price:that.rate,
            len_time:that.endTime,
            cate_id:that.cate_id,
            user_id:that.userData.id
          }
        }).then(function(response){
          var res = response.data.data;
          if(response.data.status == 200){
            that.callpay(res);
          }
        }).catch(err=>{
          console.log('请求失败:'+err);
          that.fullscreenLoading = false
        });
      },
      jsApiCall:function(msg){
        var that = this;
          WeixinJSBridge.invoke(
              'getBrandWCPayRequest',
              {
                "appId":'wxa89a20966e69c2a5',
                "timeStamp":msg.timeStamp,         //时间戳，自1970年以来的秒数     
                "nonceStr":msg.nonceStr, //随机串     
                "package":msg.package,     
                "signType":msg.signType,         //微信签名方式：     
                "paySign":msg.paySign 
              },
              function(res){
                  if(res.err_msg == "get_brand_wcpay_request:ok"){
                    window.location.href="http://user.4008005216.com/main/farmorder";
                  }else{
                     //返回跳转到订单详情页面
                      alert('支付失败');return false
                  }
              }
          );
      },

      callpay:function(data){
        if (typeof WeixinJSBridge == "undefined"){
          if( document.addEventListener ){
              document.addEventListener('WeixinJSBridgeReady', jsApiCall, false);
          }else if (document.attachEvent){
              document.attachEvent('WeixinJSBridgeReady', jsApiCall); 
              document.attachEvent('onWeixinJSBridgeReady', jsApiCall);
          }
        }else{
          this.jsApiCall(data);
        }
      },
      


      toggle:function(index){
        this.active=index;
        if(index == 3){
          this.getComment()
        }
        if(index == 4){
          this.getLog()
        }
      },
      handleScroll () {
        var scrollTop = this.scrollTop
        if (scrollTop > 135) {
          this.positionFlag = true
        } else {
          this.positionFlag = false
        }
      },
    },
  };
</script>

<style>
  .el-loading-spinner{
    width:30%;
    background:rgba(0,0,0,0.8);
    left:50%;
    transform: translateX(-50%);
    border-radius:5px;
    padding:15px 0;
    color:#fff;
  }
  .el-loading-spinner i{
    color:#fff;
    font-size:22px
  }
  .el-loading-spinner .el-loading-text{
    color:#fff;
  }
  .el-message-box{
    width:70%
  }
  .farmDetailApp{
    background:#fff;
    max-width:640px;
    margin:0 auto;
    background-size: 100% 100%;
    overflow-y: scroll;
  }
  .farmDetailApp .swiper-slide{
    width:100%
  }
  .farmDetailApp .swiper-slide img{
    display:block;
    width:100%;
  }

  .farmDetailApp .title{
    display:block;
    width:100%;
    background:rgba(255,255,255,0.8);
    padding-bottom:15px
  }
  .farmDetailApp .title h2{
    display:block;
    width:94%;
    margin:0 auto;
    font-size:16px;
    padding-top:15px;
    letter-spacing: 1px
  }
  .farmDetailApp .title p{
    display:block;
    width:94%;
    margin:0 auto;
    font-size:15px;
    padding-top:10px
  }
  .farmDetailApp .title p span{
    color:#00D138;
    padding-right:20px
  }
  .farmDetailApp .title p font{
    color:#333;
  }
  .farmDetailApp .title p.last{
    color:#FF8B18
  }

  .farmDetailApp .cate{
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    width: 94%;
    margin: 0 auto;
    padding-bottom:15px;
  }
  .farmDetailApp .cate li{
    width:48.5%;
    background:rgba(255,255,255,0.8);
    border-radius: 6px;
    margin-top:15px;
    padding-top:2px
  }
  .farmDetailApp .cate li.curt{
    border:solid 1px #FF7F00;
    padding-top:0
  }
  .farmDetailApp .cate li h2{
    text-align:center;
    font-size:16px;
    color:#333;
    padding-top:15px;
  }

  .farmDetailApp .cate li .price{
    padding-bottom:20px;
    padding-top:15px;
    text-align:center
  }
  .farmDetailApp .cate li .price span{
    text-decoration: line-through;
    color:#999;
    font-size:14px;
    padding-left:10px;
  }
  .farmDetailApp .cate li .price i{
    color: #FF1E00;
    font-style:normal;
    font-size:16px;
    font-weight:bold;
    padding:0 4px;
  }
  .farmDetailApp .cate li .price b{
    font-size:12px;
  }
  .farmDetailApp .cate li .area{
    background: rgba(255,140,25,.4);
    border-radius:0 0 6px 6px;
    text-align:center;
    padding:8px 0;
    color:#333;
    font-size:15px;
    display:block;
    width:100%
  }
  .farmDetailApp .cate li.curt .area{
    background: #FF7F00;
  }

  .farmDetailApp .tab{
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    width: 100%;
    background:rgba(255,255,255,0.8);
    height:45px;
  }
  .farmDetailApp .tab h2{
    width:25%;
    height:45px;
    line-height:45px;
    text-align:center;
    font-size:15px;
    color:#666;
    position: relative;
  }
  .farmDetailApp .tab h2.curt:after{
    position: absolute;
    content:'';
    width: 15px;
    height: 2px;
    background: #FF7F00;
    border-radius: 2px;
    left:50%;
    transform: translateX(-50%);
    top:77%
  }
  .farmDetailApp .tab h2.curt{
    color: #FF7F00;
  }

  .farmDetailApp .content{
    width: 100%;
    background:rgba(255,255,255,0.8);
    display:block;
    min-height:500px
  }

  .farmDetailApp .content .desc{
    font-size:15px;
    color:#333;
    width:92%;
    margin:0 auto;
    letter-spacing: 1px;
    line-height:22px;
  }
  .farmDetailApp .content .desc img{
    display:block;
    width:100%;
    margin:5px 0
  }

  .farmDetailApp .content .plan{
    width:92%;
    margin:0 auto;
    padding:15px 0
  }
  .farmDetailApp .content .el-step__title.is-wait{
    color:#333;
    font-weight:bold;
    font-size:15px
  }
  .farmDetailApp .content .el-step__description.is-wait,.farmDetailApp .content .el-step__head.is-wait{
    color:#666;
    font-size:14px;
    padding-bottom:10px;
  }
  .farmDetailApp .content dl{
    width:92%;
    display:block;
    margin:0 auto;
    padding-top:15px;
  }
  .farmDetailApp .content .comment{
    padding-top:10px;
  }
  .farmDetailApp .content .comment input{
    width:92%;
    display:block;
    margin:0 auto;
    background: #FFFFFF;
    border: 1px solid #FFDFBF;
    border-radius: 34px;
    height:34px;
    text-align:center;
    outline:none;
  }
  .farmDetailApp .content dl dd:after{
    display:block;clear:both;content:"";visibility:hidden;height:0
  }
  .farmDetailApp .content dl dd .avatar{
    float:left;
    width:50px;
    border-radius: 50%;
  }
  .farmDetailApp .content dl dd{
    margin-bottom:15px;
  }
  .farmDetailApp .content dl dd .plnr{
    float:left;
    width:83%;
    margin-left:2%;
    border-bottom:1px solid #EBEBEB;
  }
  .farmDetailApp .content dl dd .plnr h2 span{
    font-size:15px;
    color:#333
  }
  .farmDetailApp .content dl dd .plnr h2 font{
    float:right;
    font-weight:normal;
    font-size:15px;
    color:#999;
    margin-top:7px
  }
  .farmDetailApp .content dl dd .plnr p{
    font-size:15px;
    color:#333;
    padding-top:5px;
    letter-spacing: 1px;
    padding-bottom:15px;
  }
  .farmDetailApp .content dl dd:last-child .plnr{
    border-bottom:none;
  }
  .farmDetailApp .content dl dd .plnr .image:after,.reply:after{
    display:block;clear:both;content:"";visibility:hidden;height:0
  }
  .farmDetailApp .content dl dd .plnr .image{
    padding-bottom:15px
  }
  .farmDetailApp .content dl dd .plnr .image img{
    float:left;
    width:100%
  }

  .farmDetailApp .content .log{
    padding-top:10px;
  }
  .farmDetailApp .content .log input{
    width:92%;
    display:block;
    margin:0 auto;
    background: #FFFFFF;
    border: 1px solid #FFDFBF;
    border-radius: 34px;
    height:34px;
    text-align:center;
    outline:none;
  }
  .farmDetailApp .content .log .logBook{
    width: 92%;
    display: flex;
    margin: 0 auto;
    flex-wrap: wrap;
    justify-content: space-between;
  }
  .farmDetailApp .content .log .logBook .log-list{
    width:48.5%;
    margin-top:15px;
  }
  .farmDetailApp .content .log .logBook .log-list .img{
    display:block;
    width:100%;
    height:130px;
    border-radius: 6px;
  }
  .farmDetailApp .content .log .logBook .log-list h2{
    font-size: 15px;
    color: #333333;
    padding:8px 0
  }
  .farmDetailApp .content .log .logBook .log-list p{
    font-size: 15px;
    color: #999;
  }

  .farmDetailApp .footers{
    position:fixed;
    bottom:0;
    width:100%;
    left:0;
    height:49px;
    background: #FFFFFF;
    box-shadow: 0px 0px 10px 0px rgba(47, 120, 255, 0.2);
    z-index:99
  }
  .farmDetailApp .footers span{
    float:left;
    height:49px;
    line-height:49px;
    margin-left:15px;
    color:#666;
    font-size:15px;
  }
  .farmDetailApp .footers a{
    height: 30px;
    background: #FF7F00;
    border-radius: 30px;
    color:#fff;
    width:90px;
    text-align:center;
    line-height: 30px;
    font-size:15px;
    margin-top:9.5px;
    float:right;
    margin-right:15px
  }
  .farmDetailApp .footers .price{
    float:right;
    height:49px;
    line-height:49px;
    margin-right:10px
  }
  .farmDetailApp .footers .price i{
    color: #FF1E00;
    font-style:normal;
    font-size:16px;
    font-weight:bold;
    padding:0 4px;
  }
  .farmDetailApp .footers .price b{
    font-size:12px;
  }
</style>